import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

const Calidad = () => {
  return (
    <Container className="my-5">
      {/* Título de la Sección */}
      <Row className="mb-5">
        <Col lg={8} className="mx-auto text-center">
          <h1 className="display-4 fw-bold" style={{ color: '#2c3e50' }}>
            Sistema de Gestión de Calidad
          </h1>
          <p className="lead text-muted" style={{ fontSize: '1.8rem', color: '#b09a5b !important' }}>
            Secretaría de Gobierno
          </p>
          <div style={{ height: '4px', width: '100px', backgroundColor: '#b09a5b', margin: '20px auto' }}></div>
        </Col>
      </Row>

      {/* Contenedor de Imágenes en Vertical para Máxima Legibilidad */}
      <Row className="justify-content-center">
        <Col md={10} lg={9}>
          
          {/* Imagen 1: Misión, Visión y Objetivo */}
          <div className="mb-5 p-2 shadow-sm bg-white rounded border">
            <Image 
              src="../Img/Misionyvision2.png" 
              alt="Misión, Visión y Objetivo General" 
              fluid 
              className="w-100"
              style={{ height: 'auto', display: 'block' }} 
            />
          </div>

          {/* Imagen 2: Política y Objetivos de Calidad */}
          <div className="mb-5 p-2 shadow-sm bg-white rounded border">
            <Image 
              src="../Img/politicasdecalidad.png" 
              alt="Política y Objetivos de Calidad" 
              fluid 
              className="w-100"
              style={{ height: 'auto', display: 'block' }} 
            />
          </div>

        </Col>
      </Row>
    </Container>
  );
};

export default Calidad;